import { GET_ALL_RANKS, GET_RANK_BY_ID } from "constants/api";
import { useHistory } from "react-router-dom";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import axios, { AxiosError } from "axios";
import { useSession } from "../../../contexts/session-context";
import { LoaderContext } from "../../../contexts/loader-context";
import { TrRank } from '../../../theme/theme'
import RankingPosition from "./RankingPosition";

dayjs.extend(isBetween);
dayjs.extend(isSameOrBefore);

export default function RankingAll() {
  const history = useHistory()
  const [{ data: session }] = useSession()
  const { setLoad } = useContext(LoaderContext)
  const [currentRanking, setCurrentRanking] = useState(null)
  const [allRanking, setAllRanking] = useState([])

  const fetchRankId = async (id: number, allRanking: any = []) => {
    setLoad(true)
    try {
      setCurrentRanking(id)

      const currentRanking = allRanking.find((item: any) => item.id === id)
      if (currentRanking?.rankWinners?.length) {
        return
      }

      const ranking = await axios.get(GET_RANK_BY_ID.replace(':rankId', id.toString()), {
        headers: { Authorization: `Bearer ${((session as any)?._tokenResponse as any)?.idToken}` }
      })

      const updateAllRankingData = allRanking.map((item: any) => {
        if (item.id === id) {
          return { ...item, ...ranking.data }
        }

        return item
      })

      console.log(updateAllRankingData)

      setAllRanking(updateAllRankingData)
    } catch (error) {
      const err = error as AxiosError
      return history.push(`/error/${err.response?.data.code}`)
    } finally {
      setLoad(false)
    }
  }

  const fetchRanks = async () => {
    setLoad(true)
    try {
      const response = await axios.get(GET_ALL_RANKS, {
        headers: { Authorization: `Bearer ${((session as any)?._tokenResponse as any)?.idToken}` }
      })
      const rankingsData = response.data;
      setAllRanking(rankingsData)

      const now = dayjs();
      let targetRanking = rankingsData.find(r => now.isBetween(dayjs(r.validFrom), dayjs(r.validTo)));

      if (!targetRanking) {
        const pastRankings = rankingsData
          .filter(r => dayjs(r.validTo).isSameOrBefore(now))
          .sort((a, b) => dayjs(b.validTo).diff(dayjs(a.validTo)));

        if (pastRankings.length > 0) {
          targetRanking = pastRankings[0];
        }
      }

      if (targetRanking) {
        fetchRankId(targetRanking.id, rankingsData);
      } else {
        setLoad(false);
      }

    } catch (error) {
      const err = error as AxiosError
      history.push(`/error/${err.response?.data.code}`)
    }
  }

  useEffect(() => {
    if (session) {
      fetchRanks()
    }
  }, [])

  const ranking = useMemo(() => {
    if (!currentRanking) return null
    return allRanking.find((item: any) => item.id === currentRanking)
  }, [currentRanking, allRanking])

  const scrollContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (currentRanking && allRanking.length > 0 && scrollContainerRef.current) {
      const activeRankingIndex = allRanking.findIndex((r: any) => r.id === currentRanking);

      if (activeRankingIndex !== -1) {
        const activeElement = scrollContainerRef.current.children[activeRankingIndex] as HTMLElement;
        if (activeElement) {
          activeElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }
    }
  }, [currentRanking, allRanking]);

  return (
    <div className="flex flex-col h-full">
      <div ref={scrollContainerRef} className="flex items-end gap-2 w-full overflow-x-auto border-b px-4 mb-3 card-all-container">
        {allRanking?.map((item: any) => {
          const isFuture = dayjs(item.validFrom).isAfter(dayjs());
          return (
            <button
              key={item.id}
              onClick={() => !isFuture && fetchRankId(item.id, allRanking)}
              className={`w-full text-center card-all ${isFuture ? 'card-all-disabled' : ''} ${currentRanking === item.id ? 'card-all-active' : ''}`}
              disabled={isFuture}
            >
              <h3 className="w-max">{item?.name}</h3>
              <p className="text-sm w-max">{dayjs(item.validFrom).format('DD/MM')} - {dayjs(item.validTo).format('DD/MM')}</p>
            </button>
          )
        })}
      </div>
      <RankingPosition ranking={ranking} />
      <section className="flex-grow overflow-y-auto flex-1 px-4">
        {ranking ?
          ranking.rankWinners?.length
            ? ranking.rankWinners.filter(winner => winner.points !== 0).map((item: any, index: number) => {
              return (
                <TrRank key={index} className="din font-black text-base w-full flex items-center justify-between mb-3 card" index={index}>
                  <div className='flex items-center gap-6 user'>
                    <h5>{item?.id}.</h5>
                    <h5>{item?.profileId ? `ID: ${item?.profileId}` : 'Anónimo'}</h5>
                  </div>
                  <div className='quantity'>
                    <p>{item?.points}</p> <span>{POINTS_NAME}</span>
                  </div>
                </TrRank>
              )
            })
            : (
              <p className='rank-blank'>Aún no hay participantes, verás las posiciones aquí cuando se active.</p>
            )
          :
          (
            <p className='rank-blank'>Aún no hay participantes, verás las posiciones aquí cuando se active.</p>
          )
        }
      </section>
    </div>
  )
}